module.exports = __webpack_public_path__ + "img/seo-content-collapsible-honda.41ffe493.png";